import React from "react";

function IndustrialIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#262626"
        d="M13.544 14.223a.4.4 0 00-.4.4v.635c0 .123-.108.224-.241.224h-1.205c-.133 0-.242-.1-.242-.224v-.635a.4.4 0 00-.4-.4h-.281a.4.4 0 00-.4.4v2.338c0 .221.179.4.4.4h3.054a.4.4 0 00.4-.4v-2.338a.4.4 0 00-.4-.4h-.285zM13.144 11.671c0 .124-.108.224-.241.224h-1.205c-.133 0-.242-.1-.242-.224v-.673a.4.4 0 00-.4-.4h-.281a.4.4 0 00-.4.4v2.338c0 .221.179.4.4.4H13.829a.4.4 0 00.4-.4v-2.338a.4.4 0 00-.4-.4h-.285a.4.4 0 00-.4.4v.673z"
      ></path>
      <path
        fill="#262626"
        d="M12.665 10.598h-.723v.849h.723v-.85zM9.89 14.623a.4.4 0 00-.4-.4h-.31a.4.4 0 00-.4.4v.635c0 .123-.107.224-.24.224H7.313c-.133 0-.241-.1-.241-.224v-.635a.4.4 0 00-.4-.4h-.313a.4.4 0 00-.4.4v2.338c0 .221.18.4.4.4h3.132a.4.4 0 00.4-.4v-2.338zM6.153 1.59a.3.3 0 00-.3-.3H3.62a.3.3 0 00-.3.3v4.316a.3.3 0 00.497.226L6.049 4.2a.3.3 0 00.104-.227V1.59zM12.665 14.223h-.723v.81h.723v-.81z"
      ></path>
      <path
        fill="#262626"
        d="M8.298 14.223h-.744v.81h.744v-.81zM8.298 10.598h-.744v.849h.744v-.85z"
      ></path>
      <path
        fill="#262626"
        d="M3.321 17.707a1 1 0 001 1h11.544a1 1 0 001-1v-7.406a1 1 0 00-1-1H4.322a1 1 0 00-1 1v7.406zm2.158-3.71v-3.625c0-.123.108-.224.241-.224h8.753c.132 0 .24.1.24.224v7.211c0 .124-.107.225-.24.225H5.72c-.133 0-.241-.1-.241-.225v-3.586zM6.556 4.372l-3.313 2.87v.001l-.579.5a.633.633 0 00.414 1.112h14.027a.633.633 0 00.414-1.111l-6.118-5.3a2 2 0 00-2.619 0L6.556 4.371z"
      ></path>
      <path
        fill="#262626"
        d="M7.313 13.736H9.49a.4.4 0 00.4-.4v-2.338a.4.4 0 00-.4-.4h-.309a.4.4 0 00-.4.4v.673c0 .124-.108.224-.241.224H7.313c-.133 0-.241-.1-.241-.224v-.673a.4.4 0 00-.4-.4h-.313a.4.4 0 00-.4.4v2.338c0 .221.18.4.4.4h.954z"
      ></path>
    </svg>
  );
}

export default IndustrialIcon;
